const KeenSlider = window.KeenSlider

const { setInitialised, useDots } = window.BAO.Carousel.plugins

const { getElement } = window.BAO.Utils

class ProductDetails extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()

    this.observeItems()
  }

  setupListeners () {
    super.setupListeners()

    this.els.thumbnail.elements.forEach(el => {
      el.addEventListener('click', this.onThumbnailClick.bind(this))
    })
  }

  observeItems () {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7,
    }

    this.observerCallback = this.observerCallback.bind(this)

    const observer = new IntersectionObserver(
      this.observerCallback,
      observerOptions,
    )

    this.els.slide.elements.forEach(sec => observer.observe(sec))
  }

  observerCallback (entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const navItem = Array.from(this.els.thumbnail.elements).find(
          el => el.dataset.thumbnail === entry.target.dataset.slide,
        )

        navItem.setAttribute('aria-current', 'true')
        this.els.thumbnail.elements.forEach(el => {
          if (el !== navItem) {
            el.setAttribute('aria-current', 'false')
          }
        })
      }
    })
  }

  onThumbnailClick (e) {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const matchingEl = getElement(
      `[data-slide="${e.target.dataset.thumbnail}"]`,
      { context: this },
    )

    if (!matchingEl) return

    matchingEl.scrollIntoView({ block: 'center' })
  }

  adaptiveHeight = () => {
    return carousel => {
      function updateHeight () {
        carousel.container.style.setProperty(
          '--Height',
          `${
            carousel.slides[carousel.track.details.rel].children[0].offsetHeight
          }px`,
        )
      }
      carousel.on('created', updateHeight)
      carousel.on('slideChanged', updateHeight)
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        defaultAnimation: {
          duration: 0,
        },
        detailsChanged: s => {
          s.slides.forEach((element, idx) => {
            element.style.setProperty(
              '--Opacity',
              s.track.details.slides[idx].portion,
            )
          })
        },
        renderMode: 'custom',
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.thumbnail?.elements),
        this.adaptiveHeight(),
      ],
    )
  }
}

if (!customElements.get('product-details')) {
  customElements.define('product-details', ProductDetails)
}
